// ============================================================
// Flatsome 3.0 UX Builder deployment kit — copy/paste blocks
// ============================================================
import { FAQ_ITEMS, YEARS_IN_MARKET } from "@/data/content";

const HERO_SHORTCODE = `[ux_slider style="normal" slide_align="center" nav_style="circle" nav_color="light" bullet_style="circle" auto_slide="6000" hide_nav="false"]

[ux_banner height="640px" height__sm="560px" bg="https://images.unsplash.com/photo-1451187580459-43490279c0fa?q=80&w=1920&auto=format&fit=crop" bg_overlay="rgba(2,2,2,0.66)" bg_pos="center center"]
[text_box width="74" width__sm="94" position_x="50" position_y="50"]
<p style="color:#ff6b63; letter-spacing:4px; font-size:12px; font-weight:800; text-transform:uppercase;">Award-Winning Search Marketing &middot; Since 2006</p>
<h1 style="color:#ffffff; font-weight:800;">Be Found <span style="color:#ee2e24;">Everywhere</span> Search Happens</h1>
<p style="color:#dedede;">Google. ChatGPT. AI Overviews. Maps. We engineer visibility across every result that matters &mdash; then turn it into pipeline and revenue.</p>
[button text="Get My Free Visibility Audit" color="alert" style="shade" size="large" radius="10" link="#visibility-audit"]
[button text="See How The Machine Works" color="white" style="outline" size="large" radius="10" link="#imm"]
<p><img src="https://www.slingshotseo.com/wp-content/uploads/2019/08/recommended-company.png" alt="Slingshot SEO recommended company" width="120"> <img src="https://www.slingshotseo.com/wp-content/uploads/2019/08/inc-500-list-300x300.png" alt="Inc 500 List" width="92"></p>
[/text_box]
[/ux_banner]

[ux_banner height="640px" height__sm="560px" bg="https://images.unsplash.com/photo-1522071820081-009f0129c71c?q=80&w=1920&auto=format&fit=crop" bg_overlay="rgba(2,2,2,0.66)" bg_pos="center center"]
[text_box width="74" width__sm="94" position_x="50" position_y="50"]
<p style="color:#ff6b63; letter-spacing:4px; font-size:12px; font-weight:800; text-transform:uppercase;">New &middot; Rapid-Deployment Growth System</p>
<h1 style="color:#ffffff; font-weight:800;">The Web Marketing <span style="color:#ee2e24;">Machine&trade;</span></h1>
<p style="color:#dedede;">Pre-engineered frameworks, automation, and industry playbooks that launch in days &mdash; not quarters. SEO, GEO, PPC and Retargeting as one machine.</p>
[button text="Get My Free Visibility Audit" color="alert" style="shade" size="large" radius="10" link="#visibility-audit"]
[button text="Explore Industry Flavors" color="white" style="outline" size="large" radius="10" link="#imm"]
<p><img src="https://www.slingshotseo.com/wp-content/uploads/2019/08/recommended-company.png" alt="Slingshot SEO recommended company" width="120"> <img src="https://www.slingshotseo.com/wp-content/uploads/2019/08/inc-500-list-300x300.png" alt="Inc 500 List" width="92"></p>
[/text_box]
[/ux_banner]

[ux_banner height="640px" height__sm="560px" bg="https://images.unsplash.com/photo-1558494949-ef010cbdcc31?q=80&w=1920&auto=format&fit=crop" bg_overlay="rgba(2,2,2,0.66)" bg_pos="center center"]
[text_box width="74" width__sm="94" position_x="50" position_y="50"]
<p style="color:#ff6b63; letter-spacing:4px; font-size:12px; font-weight:800; text-transform:uppercase;">Generative Engine Optimization (GEO)</p>
<h1 style="color:#ffffff; font-weight:800;">Rank in Google. <span style="color:#ee2e24;">Get Cited by AI.</span></h1>
<p style="color:#dedede;">Our GEO practice gets your brand cited inside ChatGPT, Perplexity and Google AI Overviews &mdash; while Foundational SEO&trade; keeps you winning Page 1.</p>
[button text="Get My Free Visibility Audit" color="alert" style="shade" size="large" radius="10" link="#visibility-audit"]
[button text="See How The Machine Works" color="white" style="outline" size="large" radius="10" link="#imm"]
<p><img src="https://www.slingshotseo.com/wp-content/uploads/2019/08/recommended-company.png" alt="Slingshot SEO recommended company" width="120"> <img src="https://www.slingshotseo.com/wp-content/uploads/2019/08/inc-500-list-300x300.png" alt="Inc 500 List" width="92"></p>
[/text_box]
[/ux_banner]

[ux_banner height="640px" height__sm="560px" bg="https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=1920&auto=format&fit=crop" bg_overlay="rgba(2,2,2,0.66)" bg_pos="center center"]
[text_box width="74" width__sm="94" position_x="50" position_y="50"]
<p style="color:#ff6b63; letter-spacing:4px; font-size:12px; font-weight:800; text-transform:uppercase;">Advanced PPC + Precision Retargeting</p>
<h1 style="color:#ffffff; font-weight:800;">SEO Builds. PPC Accelerates. <span style="color:#ee2e24;">Retargeting Converts.</span></h1>
<p style="color:#dedede;">Capture high-intent demand today and re-engage the 97% who don't convert &mdash; paid media engineered to amplify every organic gain.</p>
[button text="Get My Free Visibility Audit" color="alert" style="shade" size="large" radius="10" link="#visibility-audit"]
[button text="See How The Machine Works" color="white" style="outline" size="large" radius="10" link="#imm"]
<p><img src="https://www.slingshotseo.com/wp-content/uploads/2019/08/recommended-company.png" alt="Slingshot SEO recommended company" width="120"> <img src="https://www.slingshotseo.com/wp-content/uploads/2019/08/inc-500-list-300x300.png" alt="Inc 500 List" width="92"></p>
[/text_box]
[/ux_banner]

[/ux_slider]`;

const SERVICES_BAND_SHORTCODE = `[section padding="70px"]
[row]

[col span="4" span__md="6" span__sm="12"]
[featured_box img="ICON_SEARCH_SVG" img_width="44" pos="left" margin="0 0 30px 0"]
<h5 class="uppercase">Foundational SEO&trade;</h5>
<p>The technical bedrock: fast, secure, crawlable, mobile-flawless websites that search engines &mdash; and AI models &mdash; trust.</p>
[/featured_box]
[featured_box img="ICON_SPARKLES_SVG" img_width="44" pos="left" margin="0 0 30px 0"]
<h5 class="uppercase">Generative Engine Optimization</h5>
<p>Entities, answers and authority engineered so ChatGPT, Perplexity and Google AI Overviews cite your brand &mdash; not your competitor's.</p>
[/featured_box]
[featured_box img="ICON_CLICK_SVG" img_width="44" pos="left" margin="0 0 30px 0"]
<h5 class="uppercase">Advanced PPC Management</h5>
<p>High-intent paid search with engineered landing pages and bid automation &mdash; capturing demand today while organic compounds.</p>
[/featured_box]
[/col]

[col span="4" span__md="6" span__sm="12"]
[featured_box img="ICON_REPEAT_SVG" img_width="44" pos="left" margin="0 0 30px 0"]
<h5 class="uppercase">Precision Retargeting</h5>
<p>Segmented remarketing across display, social and video that turns the 97% of visitors who leave into pipeline.</p>
[/featured_box]
[featured_box img="ICON_TRENDING_SVG" img_width="44" pos="left" margin="0 0 30px 0"]
<h5 class="uppercase">Conversion Optimization</h5>
<p>A/B testing, heat-mapping and funnel analysis that squeeze more leads and sales from every visit you already earn.</p>
[/featured_box]
[featured_box img="ICON_LINK_SVG" img_width="44" pos="left" margin="0 0 30px 0"]
<h5 class="uppercase">White Hat, Premium Link Building</h5>
<p>Contextually relevant, permanent placements that build a natural, zero-toxicity authority profile algorithms and AI reward.</p>
[/featured_box]
[/col]

[col span="4" span__md="12" span__sm="12"]
<h3 id="visibility-audit">Free Visibility Audit</h3>
[row_inner]
[col_inner span="12" bg_color="rgb(239, 238, 238)" padding="22px 22px 22px 22px"]
<p style="font-size:13px;">See exactly where you stand in Google, AI search and paid media &mdash; and the fastest path to more leads.</p>
[gravityform id="1" title="false" description="false" ajax="true"]
<p style="font-size:12px;">*We will get back to you in 2 business days or less!</p>
[/col_inner]
[/row_inner]
[/col]

[/row]
[/section]`;

const ABOUT_AWARDS_SHORTCODE = `[section bg_color="rgb(250,250,250)" padding="70px"]
[row]
[col span="12"]
<h5>Slingshot SEO is a full-service search marketing practice. Since 2006, our strategic consulting and hands-on execution have delivered unparalleled results for enterprise-caliber clients &mdash; across Google, AI engines and paid media.</h5>
<p><img class="cimg" src="https://images.unsplash.com/photo-1552664730-d307ca884978?q=80&w=1200&auto=format&fit=crop" alt="Slingshot SEO strategy session" width="300"></p>
<p>Search has changed. Your customers don't just Google anymore &mdash; they ask ChatGPT, scan AI Overviews, compare options in the map pack, and click ads long before they ever reach your website. Winning today means being present, credible and persuasive at every one of those moments.</p>
<p>Our delivery model is built on the same CLASS framework that made us an Inc. 500 company &mdash; Content, Links, Architecture, Social and Strategy &mdash; now supercharged for the AI era with entity optimization, answer-ready content and structured data that generative engines can trust and cite.</p>
[/col]
[col span="12"]
<p><img class="cimg" src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=1200&auto=format&fit=crop" alt="Performance marketing analytics" width="300"></p>
<p>But visibility without conversion is just noise. That's why advanced PPC captures high-intent demand the moment it appears, and precision retargeting brings back the 97% of visitors who leave without acting. Organic builds the asset; paid compounds the return.</p>
<p>The result is one accountable growth system &mdash; strategy, execution and reporting tied to leads and sales, not vanity metrics. Experience what a modern, full-service search partner can do for your company.</p>
[/col]
[col span="12" align="center"]
<img src="https://www.slingshotseo.com/wp-content/uploads/2017/12/Awards.png" alt="Slingshot SEO awards and recognition" width="957" height="89">
[/col]
[/row]
[/section]`;

const OUTCOMES_SHORTCODE = `[section bg="https://images.unsplash.com/photo-1504384308090-c894fdcc538d?q=80&w=1920&auto=format&fit=crop" bg_overlay="rgba(2,2,2,0.78)" dark="true" padding="90px" parallax="3"]
[row v_align="middle"]

[col span="6" span__sm="12" align="center"]
<!-- Paste the "Visibility Scorecard" HTML from the Dynamic Element Blocks section below (UX Builder > HTML element). Animated bars + CSS included - no screenshot needed. -->
[/col]

[col span="6" span__sm="12"]
<h3 class="redul">Increase Traffic, Leads and Sales</h3>
[featured_box img="ICON_TROPHY_SVG" img_width="26" pos="left" margin="0 0 18px 0"]<h3>Own Page 1 &mdash; and the AI answers above it</h3>[/featured_box]
[featured_box img="ICON_GAUGE_SVG" img_width="26" pos="left" margin="0 0 18px 0"]<h3>Reach results faster with our StrikingDistance&trade; methodology</h3>[/featured_box]
[featured_box img="ICON_LAYERS_SVG" img_width="26" pos="left" margin="0 0 18px 0"]<h3>Full-funnel coverage: SEO + GEO + PPC + Retargeting</h3>[/featured_box]
[featured_box img="ICON_SHIELD_SVG" img_width="26" pos="left" margin="0 0 18px 0"]<h3>Tracking you can trust &mdash; every dollar tied to revenue</h3>[/featured_box]
[featured_box img="ICON_GRAD_SVG" img_width="26" pos="left" margin="0 0 18px 0"]<h3>Serviced by US-based marketing professionals with MBAs and certifications</h3>[/featured_box]
[button text="Get My Free Visibility Audit" color="alert" style="shade" size="large" radius="10" link="#visibility-audit"]
[/col]

[/row]
[/section]`;

const IMM_SHORTCODE = `[section padding="85px"]
[row]
[col span="10" align="center"]
<p style="color:#ee2e24; letter-spacing:4px; font-size:12px; font-weight:800; text-transform:uppercase;">New &middot; From Slingshot SEO</p>
<h2 style="font-weight:800;">The Web Marketing Machine&trade;</h2>
<p>Stop buying marketing piecemeal. The Machine is our rapid-deployment growth system &mdash; pre-engineered frameworks, automation and industry playbooks that launch in days, not quarters.</p>
[/col]
[/row]

[row v_align="middle"]
[col span="6" span__sm="12"]
[featured_box img="ICON_ROCKET_SVG" img_width="40" pos="left" margin="0 0 26px 0"]
<h4>Rapid Deployment</h4>
<p>Launch-ready frameworks with schema, FAQ modules and content rotators built in &mdash; live in days, not quarters.</p>
[/featured_box]
[featured_box img="ICON_WORKFLOW_SVG" img_width="40" pos="left" margin="0 0 26px 0"]
<h4>Automation at the Core</h4>
<p>Lead routing, review generation, reporting and campaign optimization run on autopilot &mdash; your team stays focused on closing.</p>
[/featured_box]
[featured_box img="ICON_LAYERS_SVG" img_width="40" pos="left" margin="0 0 26px 0"]
<h4>Every Channel, One System</h4>
<p>Foundational SEO&trade;, GEO, advanced PPC and Retargeting engineered to work as a single, accountable growth engine.</p>
[/featured_box]
[featured_box img="ICON_BARCHART_SVG" img_width="40" pos="left" margin="0 0 26px 0"]
<h4>Revenue-Tied Reporting</h4>
<p>Dashboards that connect visibility to leads and sales &mdash; never vanity metrics.</p>
[/featured_box]
[button text="Get My Free Visibility Audit" color="alert" style="shade" size="large" radius="10" link="#visibility-audit"]
[/col]

[col span="6" span__sm="12"]
<!-- Paste the "Machine Diagram" HTML from the Dynamic Element Blocks section below (UX Builder > HTML element). Spinning Automation Core + hover effects included - no screenshot needed. -->
[/col]
[/row]

[row label="Industry Flavors"]
[col span="2" span__md="4" span__sm="6" align="center"] [featured_box img="ICON_SCALE_SVG" img_width="34" pos="top"]<h5>Legal</h5><p style="font-size:12px;">Case-driving visibility for firms in competitive markets.</p>[/featured_box] [/col]
[col span="2" span__md="4" span__sm="6" align="center"] [featured_box img="ICON_HEART_SVG" img_width="34" pos="top"]<h5>Healthcare</h5><p style="font-size:12px;">Compliant patient acquisition for practices and systems.</p>[/featured_box] [/col]
[col span="2" span__md="4" span__sm="6" align="center"] [featured_box img="ICON_HAMMER_SVG" img_width="34" pos="top"]<h5>Home Services</h5><p style="font-size:12px;">Own the map pack and the phone in every service area.</p>[/featured_box] [/col]
[col span="2" span__md="4" span__sm="6" align="center"] [featured_box img="ICON_CART_SVG" img_width="34" pos="top"]<h5>E-Commerce</h5><p style="font-size:12px;">Product visibility from search to shopping to retargeting.</p>[/featured_box] [/col]
[col span="2" span__md="4" span__sm="6" align="center"] [featured_box img="ICON_SHIELD_SVG" img_width="34" pos="top" link="/insurance-marketing-machine/"]<h5>Insurance Services</h5><p style="font-size:12px;">Policyholder acquisition and trust-first visibility for agencies and carriers.</p>[/featured_box] [/col]
[col span="2" span__md="4" span__sm="6" align="center"] [featured_box img="ICON_GRAD_SVG" img_width="34" pos="top" link="/education-marketing-machine/"]<h5>Education</h5><p style="font-size:12px;">Enrollment-driving visibility for schools, universities and edtech.</p>[/featured_box] [/col]
[/row]
[/section]`;

const RECIPE_SHORTCODE = `[section bg_color="rgb(250,250,250)" padding="75px"]
[row]
[col span="12" align="center"]
<h3 class="ctr-red-ul">Our recipe for consistent search results</h3>
[/col]
[/row]

[row label="Recipe Row 1"]
[col span="3" span__md="6" span__sm="12"]
[featured_box img="ICON_SHIELD_SVG" img_width="42" pos="top" title="Foundational SEO™"]
<ul><li>Mobile-responsiveness compliance</li><li>Core Web Vitals &amp; site speed</li><li>Site-wide SSL &amp; layered security</li><li>Clean, crawlable architecture</li><li>24/7 uptime management</li></ul>
[/featured_box]
[/col]
[col span="3" span__md="6" span__sm="12"]
[featured_box img="ICON_SPARKLES_SVG" img_width="42" pos="top" title="GEO & AI Search"]
<ul><li>AI Overview optimization</li><li>Entity &amp; knowledge graph building</li><li>Answer-ready content engineering</li><li>AI crawler readiness (llms.txt)</li><li>Citation tracking across AI engines</li></ul>
[/featured_box]
[/col]
[col span="3" span__md="6" span__sm="12"]
[featured_box img="ICON_TARGET_SVG" img_width="42" pos="top" title="Advanced PPC"]
<ul><li>High-intent keyword bidding</li><li>Performance Max &amp; Shopping</li><li>Landing page engineering</li><li>Conversion tracking &amp; attribution</li><li>Budget &amp; bid automation</li></ul>
[/featured_box]
[/col]
[col span="3" span__md="6" span__sm="12"]
[featured_box img="ICON_REPEAT_SVG" img_width="42" pos="top" title="Retargeting & Remarketing"]
<ul><li>Audience segmentation</li><li>Display, social &amp; video sequencing</li><li>Dynamic product retargeting</li><li>Creative testing at scale</li><li>Frequency &amp; fatigue management</li></ul>
[/featured_box]
[/col]
[/row]

[gap height="30px"]

[row label="Recipe Row 2"]
[col span="3" span__md="6" span__sm="12"]
[featured_box img="ICON_FILETEXT_SVG" img_width="42" pos="top" title="Content & Schema"]
<ul><li>Keyword-rich, answer-first copy</li><li>Schema &amp; structured data</li><li>FAQ modules &amp; rich results</li><li>Blog strategy &amp; digital PR</li><li>Content rotators</li></ul>
[/featured_box]
[/col]
[col span="3" span__md="6" span__sm="12"]
[featured_box img="ICON_MAPPIN_SVG" img_width="42" pos="top" title="Local Search Domination"]
<ul><li>Google Business Profile management</li><li>Map pack optimization</li><li>Location page build-out</li><li>Review generation strategy</li><li>Local keyword strategy</li></ul>
[/featured_box]
[/col]
[col span="3" span__md="6" span__sm="12"]
[featured_box img="ICON_TRENDING_SVG" img_width="42" pos="top" title="Conversion Optimization"]
<ul><li>A/B &amp; multivariate testing</li><li>Heat-mapping &amp; session replay</li><li>Funnel analysis</li><li>Form &amp; CTA optimization</li><li>Landing page experimentation</li></ul>
[/featured_box]
[/col]
[col span="3" span__md="6" span__sm="12"]
[featured_box img="ICON_RADAR_SVG" img_width="42" pos="top" title="Competitive Intelligence"]
<ul><li>Gap link analysis</li><li>Competitor ad monitoring</li><li>Keyword opportunity mining</li><li>AI citation share tracking</li><li>Organic rank monitoring</li></ul>
[/featured_box]
[/col]
[/row]
[/section]`;

const STATS_SHORTCODE = `[section bg="https://images.unsplash.com/photo-1550751827-4bd374c3f58b?q=80&w=1920&auto=format&fit=crop" bg_overlay="rgba(2,2,2,0.82)" dark="true" padding="90px" parallax="3"]
[row]
[col span="3" span__sm="6" align="center"]
<h2 style="font-size:54px; font-weight:900; color:#ffffff; margin-bottom:4px;">887<span style="color:#ee2e24;">+</span></h2>
<h3 style="letter-spacing:4px; font-size:12px; color:#bdbdbd; text-transform:uppercase;">Clients</h3>
[/col]
[col span="3" span__sm="6" align="center"]
<h2 style="font-size:54px; font-weight:900; color:#ffffff; margin-bottom:4px;">751</h2>
<h3 style="letter-spacing:4px; font-size:12px; color:#bdbdbd; text-transform:uppercase;">Optimized Websites</h3>
[/col]
[col span="3" span__sm="6" align="center"]
<h2 style="font-size:54px; font-weight:900; color:#ffffff; margin-bottom:4px;">98<span style="color:#ee2e24;">%</span></h2>
<h3 style="letter-spacing:4px; font-size:12px; color:#bdbdbd; text-transform:uppercase;">Client Satisfaction</h3>
[/col]
[col span="3" span__sm="6" align="center"]
<h2 style="font-size:54px; font-weight:900; color:#ffffff; margin-bottom:4px;">${YEARS_IN_MARKET}</h2>
<h3 style="letter-spacing:4px; font-size:12px; color:#bdbdbd; text-transform:uppercase;">Years of Service</h3>
[/col]
[/row]
[/section]

<!-- ALTERNATIVE: keep your existing "Counter Number Showcase" plugin shortcodes and simply update the values: Clients 587 -> 887, Years 14 -> ${YEARS_IN_MARKET}. Websites (751) and Satisfaction (98) stay unchanged. -->`;

const FAQ_SHORTCODE_ITEMS = FAQ_ITEMS.map(
  (item) => '[accordion-item title="' + item.q + '"]\n' + item.a + "\n[/accordion-item]"
).join("\n\n");

const FAQ_SHORTCODE = `[section padding="70px"]
[row]
[col span="10" align="center"]
<p style="color:#ee2e24; letter-spacing:4px; font-size:12px; font-weight:800; text-transform:uppercase;">FAQ</p>
<h3>Straight answers to modern search questions</h3>
[/col]
[/row]
[row]
[col span="10"]
[accordion]
${FAQ_SHORTCODE_ITEMS}
[/accordion]
[/col]
[/row]
[/section]`;

// ---------- JSON-LD Schemas ----------
export const ORG_SCHEMA_OBJ = {
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  name: "Slingshot SEO",
  url: "https://www.slingshotseo.com/",
  logo: "https://www.slingshotseo.com/wp-content/uploads/2018/01/logo.png",
  description:
    "Full-service search marketing: Foundational SEO, Generative Engine Optimization (GEO), advanced PPC and Retargeting — plus The Web Marketing Machine rapid-deployment growth system.",
  foundingDate: "2006",
  slogan: "Be Found Everywhere Search Happens",
  award: "Inc. 500 List",
  areaServed: "United States",
  sameAs: [
    "https://www.facebook.com/pg/slingshotseo/about/",
    "https://twitter.com/slingshotseo",
    "https://www.linkedin.com/company/27161257",
  ],
  knowsAbout: [
    "Search Engine Optimization",
    "Generative Engine Optimization",
    "Pay-Per-Click Advertising",
    "Retargeting",
    "Conversion Rate Optimization",
    "Local SEO",
  ],
};

export const FAQ_SCHEMA_OBJ = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQ_ITEMS.map((item) => ({
    "@type": "Question",
    name: item.q,
    acceptedAnswer: { "@type": "Answer", text: item.a },
  })),
};

const ORG_SCHEMA_SNIPPET =
  '<script type="application/ld+json">\n' + JSON.stringify(ORG_SCHEMA_OBJ, null, 2) + "\n</script>";
const FAQ_SCHEMA_SNIPPET =
  '<script type="application/ld+json">\n' + JSON.stringify(FAQ_SCHEMA_OBJ, null, 2) + "\n</script>";

const GRAVITY_FORMS_NOTES = `GRAVITY FORMS PLACEMENT (Flatsome 3.0)
=====================================
1. The demo form maps 1:1 to your existing Gravity Form #1 fields:
   - Full Name*  -> input_1 (Name)
   - Email*      -> input_2 (Email)
   - Phone*      -> input_6 (Phone)
   - Company*    -> input_3 (Company Name)
   - Website*    -> input_5 (Website)
   Keep the honeypot (input_8) and invisible reCAPTCHA exactly as configured today.

2. Update the form heading from "Free SEO Analysis" to "Free Visibility Audit"
   and the submit button value from "Get Free Report" to "Get My Free Audit".

3. Paste this where the demo form panel sits (3rd column of the services band):
   [gravityform id="1" title="false" description="false" ajax="true"]

4. Keep the reassurance line under the form:
   *We will get back to you in 2 business days or less!

5. Confirmation message suggestion:
   "Request received! A US-based strategist will review your visibility across
   Google, AI search and paid media — and get back to you within 2 business days."`;

const ASSETS_NOTES = `ASSET & DEPLOYMENT CHECKLIST
============================
LOCKED BRAND ASSETS (already in your WP media library):
- Logo:              /wp-content/uploads/2018/01/logo.png
- Recommended badge: /wp-content/uploads/2019/08/recommended-company.png
- Inc 500 badge:     /wp-content/uploads/2019/08/inc-500-list-300x300.png
- Awards strip:      /wp-content/uploads/2017/12/Awards.png

NEW IMAGERY (demo placeholders — replace with licensed/curated shots):
- Hero slide 1 (Flagship): https://images.unsplash.com/photo-1451187580459-43490279c0fa
- Hero slide 2 (IMM):      https://images.unsplash.com/photo-1522071820081-009f0129c71c
- Hero slide 3 (GEO):      https://images.unsplash.com/photo-1558494949-ef010cbdcc31
- Hero slide 4 (PPC):      https://images.unsplash.com/photo-1551288049-bebda4e38f71
- Outcomes bg:             https://images.unsplash.com/photo-1504384308090-c894fdcc538d
- Stats bg:                https://images.unsplash.com/photo-1550751827-4bd374c3f58b
- About img 1:             https://images.unsplash.com/photo-1552664730-d307ca884978
- About img 2:             https://images.unsplash.com/photo-1460925895917-afdab827c52f

MODERN LINE ICONS:
- EASIEST: the Deploy Engine (/deploy) generates all 26 icons as brand-red
  PNGs (#ee2e24, 128px, transparent) and uploads them to your media library
  automatically as ss3-icon-<name>.png.
- MANUAL: download slingshot-icon-kit.zip from the Deploy Engine page.
  PNGs upload to WordPress natively - no SVG-enabling plugin required.
- Icon set (lucide.dev, ISC license): Search, Sparkles, MousePointerClick,
  Repeat, TrendingUp, Link-2, Trophy, Gauge, Layers, ShieldCheck,
  GraduationCap, Rocket, Workflow, BarChart3, Scale, HeartPulse, Hammer,
  ShoppingCart, Building2, Store, Target, FileText, MapPin, Radar, Cog, Check.

DYNAMIC ELEMENTS (no screenshots needed):
- Visibility Scorecard, Machine Diagram, Industry Cards and Count-up Stats
  ship as scoped HTML/CSS/JS blocks (see 'Dynamic Element Blocks' on this
  page). Paste into UX Builder's HTML element - animations survive intact.
- The Deploy Engine places all of them automatically.

SCHEMA PLACEMENT:
- Paste both JSON-LD snippets into the homepage <head> via Flatsome's
  Theme Options > Advanced > Global Settings > Head Scripts (homepage only),
  or a header/footer scripts plugin.`;

export const EXPORT_BLOCKS = [
  {
    key: "hero",
    title: "1. Hero Rotator (4 slides)",
    description:
      "Full-width [ux_slider] with 4 [ux_banner] slides — autoplay 6s, circle nav, trust badges on every slide. Replaces the current 2-slide hero.",
    notes: [
      "Upload hero backgrounds to the media library and swap the Unsplash URLs.",
      "Buttons link to #visibility-audit (form panel) and #imm (Machine section).",
      "color=\"alert\" renders the red CTA — confirm your Flatsome alert color is #ee2e24 (Theme Options > Style).",
    ],
    code: HERO_SHORTCODE,
  },
  {
    key: "services-band",
    title: "2. Services Band + Visibility Audit Form",
    description:
      "Same 3-column layout as today: two columns of icon boxes (now SEO / GEO / PPC / Retargeting / CRO / Links) + the gray form panel with Gravity Forms.",
    notes: [
      "EASIEST: run the Deploy Engine (/deploy) — it generates all icons as brand-red PNGs and uploads them to your media library automatically (ss3-icon-*.png).",
      "Manual: download the ready-made PNG icon kit from the Deploy Engine page (no SVG plugin needed), upload, and swap the ICON_*_SVG placeholders.",
      "The h3 carries id=\"visibility-audit\" so hero CTAs anchor to it.",
    ],
    code: SERVICES_BAND_SHORTCODE,
  },
  {
    key: "about-awards",
    title: "3. Philosophy / About + Awards Strip",
    description:
      "Refreshed long-form positioning copy (CLASS framework evolved for the AI era) with the existing Awards strip preserved.",
    notes: ["Keeps your existing .cimg image styling class from the child theme."],
    code: ABOUT_AWARDS_SHORTCODE,
  },
  {
    key: "outcomes",
    title: "4. Dark Outcomes Section (parallax)",
    description:
      "Same dark parallax band — modernized bullets covering Page 1 + AI answers, StrikingDistance™, full-funnel coverage, trustworthy tracking, US-based team.",
    notes: [
      "Uses your existing .redul red-underline heading class.",
      "The scorecard is a live animated HTML block now — grab it from 'Dynamic Element Blocks' below, or let the Deploy Engine place it automatically.",
    ],
    code: OUTCOMES_SHORTCODE,
  },
  {
    key: "imm",
    title: "5. The Web Marketing Machine™ (NEW)",
    description:
      "The one new structural section: feature bullets, Machine diagram, and 6 industry flavor cards (Legal, Healthcare, Home Services, E-Commerce, Insurance Services, Education).",
    notes: [
      "Insert between the dark outcomes section and the recipe grid.",
      "The Machine diagram is a live animated HTML block now — grab it from 'Dynamic Element Blocks' below, or let the Deploy Engine place it automatically.",
    ],
    code: IMM_SHORTCODE,
  },
  {
    key: "recipe",
    title: "6. Recipe Grid (8 refreshed cards)",
    description:
      "Same 2x4 card grid under 'Our recipe for consistent search results' — cards now cover Foundational SEO™, GEO & AI Search, Advanced PPC, Retargeting, Content & Schema, Local, CRO, and Competitive Intelligence.",
    notes: ["Uses your existing .ctr-red-ul centered red-underline heading class."],
    code: RECIPE_SHORTCODE,
  },
  {
    key: "stats",
    title: "7. Stats Band (updated numbers)",
    description:
      "Clients updated 587 -> 887 (+300). Years of Service computed from 2006 (" +
      YEARS_IN_MARKET +
      " this year). Websites and Satisfaction unchanged.",
    notes: [
      "Option A: static markup below. Option B: use the animated count-up version from 'Dynamic Element Blocks' (HTML + JS, no plugin). Option C: keep the Counter Number Showcase plugin and just update its values.",
    ],
    code: STATS_SHORTCODE,
  },
  {
    key: "faq",
    title: "8. FAQ Accordion (NEW)",
    description:
      "Six conversion-focused questions covering GEO, PPC/Retargeting, The Machine, the Visibility Audit, and time-to-results. Matches the FAQPage schema below word-for-word.",
    notes: ["Place directly above the footer."],
    code: FAQ_SHORTCODE,
  },
  {
    key: "org-schema",
    title: "9. Organization Schema (JSON-LD)",
    description: "ProfessionalService schema declaring the full-service offering, Inc. 500 award and founding date.",
    notes: ["Paste into the site <head> (homepage) — see checklist block for placement options."],
    code: ORG_SCHEMA_SNIPPET,
  },
  {
    key: "faq-schema",
    title: "10. FAQPage Schema (JSON-LD)",
    description: "Generated from the exact FAQ copy above — eligible for rich results and quotable by AI engines.",
    notes: ["Must match the visible FAQ content — if you edit an answer, update both."],
    code: FAQ_SCHEMA_SNIPPET,
  },
  {
    key: "gravity-forms",
    title: "11. Gravity Forms Notes",
    description: "Field mapping and copy updates so the existing form drops in without layout changes.",
    notes: [],
    code: GRAVITY_FORMS_NOTES,
  },
  {
    key: "assets",
    title: "12. Asset & Deployment Checklist",
    description: "Every image URL, icon source and placeholder used in the demo — plus schema placement instructions.",
    notes: [],
    code: ASSETS_NOTES,
  },
];
